import axios from "axios";
import axiosConfig from "./config"; // axios请求配置
import apiArr from "./api"; // 用户请求集合
import qs from "qs";
import { Message } from "element-ui";

// import store from "./store";
// import router from './router';
import router from "@/router";
import { getToken } from "@/utils/auth";

// 创建axios实例
const service = axios.create({
  baseURL: axiosConfig.baseURL,
  timeout: axiosConfig.timeout,
  // headers: axiosConfig.headers
  headers: { ssotoken: sessionStorage.getItem("token") }
  // headers: {'ssotoken':getToken()}
});

// 添加请求拦截器
service.interceptors.request.use(
  function(config) {
    //  promise动态添加请求头，加完之后再return出config继续请求
    const headerHandlers = (axiosConfig.headerHandlers || []).map(handler => {
      return handler(config).then(mixHeaders =>
        Object.assign(config.headers || {}, mixHeaders)
      );
    });
    return Promise.all(headerHandlers).then(() => config);
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    // token失效
    console.log("http.code:", response.data.code);
    if (response.data.code == 10000) {
      return response.data.data;
    } else if (response.data.code == 190003 || response.data.code == "190003") {
      // router.push({
      //   path: '/login'
      // });
      //Message.error("重新登录")
      router.push("/login");
    } else {
      Message.error(response.data.desc);
      //停止promise链
      return new Promise(() => {});
    }
  },
  function(error) {
    // 对响应错误做点什么
    Message.error(error.message);
    return Promise.reject(error);
  }
);

// 创建请求
const USE_DATA_METHODS = ["POST", "PUT", "PATCH", "DELETE"];
const createRequest = () => {
  const hostApi = {};
  apiArr.forEach(api => {
    hostApi[api.name] = params => {
      const method = api.method || "POST";
      const requestParams = USE_DATA_METHODS.includes(method)
        ? { data: qs.stringify(params) }
        : { params: params };
      return service({
        url: api.path,
        method,
        headers: {
          ...api.headers
        },
        ...requestParams
      });
    };
  });
  return hostApi;
};

const apis = createRequest();

export default apis;



// WEBPACK FOOTER //
// ./src/request/http.js